import React, { useEffect, useState } from "react";

import { getProductsCategories } from "Requests/Categories";
import { GetComboInProducts } from "Requests/Products";

import Input from "Components/Form/Input";
import Select from "Components/Form/Select";
import SelectSearch from "Components/Form/SelectSearch";
import PanelContent from "Components/Panels/PanelContent";
import { Box } from "styles/globalComponents";
import { Button } from "Components/Button";
import { getUnitQRcode } from "Requests/Unit";
import { useQuery } from "react-query";
import { Field, useFormikContext } from "formik";
import { getRegions, unitsScheduleCombo } from "Requests/Units";
import { CATEGORIES } from "Constants/Categories";

const unitTypes = [
  { id: "exames", name: "Exames" },
  { id: "clinica", name: "Clínica" },
  { id: "domiciliar", name: "Domiciliar" },
];

export function GeneralInfo({ unitId }) {
  const {
    values,
    errors,
    handleChange: handleChangeFormik,
    setFieldValue,
    setFieldError,
  } = useFormikContext();

  const [isDownloadingQr, setIsDownloadingQr] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState(null);

  const { data: combos } = useQuery({
    queryKey: ["channels"],
    queryFn: GetComboInProducts,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const { data: unitCombos } = useQuery({
    queryKey: ["unit-combos"],
    queryFn: unitsScheduleCombo,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const { data: categories } = useQuery({
    queryKey: ["products-categories"],
    queryFn: getProductsCategories,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const filteredCategories = categories?.filter(
    (category) =>
      category.id !== CATEGORIES.vaccine && category.id !== CATEGORIES.image
  );

  const { data: regions } = useQuery({
    queryKey: ["units-regions"],
    queryFn: getRegions,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const { refetch: refetchQrCode } = useQuery({
    queryKey: ["units-regions"],
    queryFn: () => getUnitQRcode(unitId),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: false,
  });

  // const getQrcode = async () => {
  //   try {
  //     setIsDownloadingQr(true);
  //     await getUnitQRcode(unitId);
  //   } finally {
  //     setIsDownloadingQr(false);
  //   }
  // };

  const regionsList = regions?.map((region) => ({
    id: region.id,
    region: region.region,
  }));

  const handleSetValue = (field, type) => {
    const updatedValues = new Set([...type]);

    setFieldValue(field, Array.from(updatedValues));
    setFieldError(field, undefined);
  };

  const handleSetRegionValue = (type) => {
    setSelectedRegion(type);
    setFieldValue("region_id", type.id);
    setFieldError("region_id", undefined);
  };

  const handleChange = (e) => {
    handleChangeFormik(e);
    setFieldError(e.target.name, undefined);
  };

  useEffect(() => {
    if (unitId)
      setSelectedRegion(
        regionsList?.find((region) => region.id === values.region_id)
      );
  }, [values]);

  return (
    <PanelContent title="Informações Gerais">
      <div className="row">
        <div className="md-6">
          <Field
            label="Nome da unidade*"
            type="text"
            maxLength={255}
            id="name"
            value={values.name}
            error={errors.name}
            onChange={handleChange}
            component={Input}
            validate
          />
        </div>
        <div className="md-6">
          <Field
            label="Slug*"
            type="text"
            id="slug"
            maxLength={255}
            value={values.slug}
            error={errors.slug}
            component={Input}
            onChange={handleChange}
          />
        </div>
        <div className="md-6">
          <Field
            component={SelectSearch}
            label="Canais Disponíveis"
            id="channels_ids"
            type="text"
            value={values.channels_ids}
            error={errors.channels_ids}
            isMulti
            options={combos?.channels}
            loading={combos?.channels?.length === 0}
            readOnly={combos?.channels?.length === 0}
            valueKey="name"
            labelKey="name"
            placeholder="Canais permitido"
            onChange={(value) => handleSetValue("channels_ids", value)}
          />
        </div>
        <div className="md-6">
          <Field
            component={Input}
            label="Motion Código*"
            type="text"
            id="motion_code"
            maxLength={4}
            value={values.motion_code}
            error={errors.motion_code}
            onChange={handleChange}
          />
        </div>

        {unitId && (
          <div className="md-6">
            <Field
              component={SelectSearch}
              label="Convênios"
              id="covenant_ids"
              type="text"
              value={values.covenant_ids}
              error={errors.covenant_ids}
              isMulti
              options={unitCombos?.covenants}
              loading={unitCombos?.covenants?.length === 0}
              readOnly={
                unitCombos?.covenants?.length === 0 ||
                !unitCombos?.covenants ||
                unitId
              }
              valueKey="covenant"
              labelKey="covenant"
              placeholder="Convênios permitidos"
              onChange={(value) => handleSetValue("covenant_ids", value)}
            />
          </div>
        )}

        <div className="md-6">
          <Field
            component={SelectSearch}
            label="Regiões*"
            id="region_id"
            type="text"
            value={selectedRegion}
            error={errors.region_id}
            isMoreSelect={false}
            isMulti
            options={regionsList}
            loading={regions?.length === 0}
            readOnly={regions?.length === 0}
            valueKey="region"
            labelKey="region"
            placeholder="Regiões permitidas"
            onChange={(value) => handleSetRegionValue(value)}
          />
        </div>
        <div className="md-6">
          <Field
            component={Input}
            label="Caixa*"
            type="text"
            id="cashier"
            value={values.cashier}
            error={errors.cashier}
            maxLength={45}
            onChange={handleChange}
          />
        </div>
        <div className="md-6">
          <Field
            component={Input}
            label="Agenda de Exames da Unidade"
            type="text"
            id="exam_schedule"
            maxLength={255}
            value={values.exam_schedule}
            error={errors.exam_schedule}
            onChange={handleChange}
          />
        </div>
        <div className="sm-6">
          <Field
            component={Select}
            label="Tipo de Unidade*"
            id="type"
            placeholder="Informe o Tipo da Unidade"
            value={values.type}
            error={errors.type}
            options={unitTypes}
            onChange={handleChange}
          />
        </div>
        <div className="sm-6">
          <Field
            component={SelectSearch}
            label="Serviços atendidos*"
            id="category_ids"
            type="text"
            value={values.category_ids}
            error={errors.category_ids}
            isMulti
            options={filteredCategories}
            loading={categories?.length === 0}
            readOnly={categories?.length === 0 || !categories}
            valueKey="category"
            labelKey="category"
            required
            placeholder="Serviços atendidos"
            onChange={(value) => handleSetValue("category_ids", value)}
          />
        </div>
        <div className="sm-6">
          <Field
            component={Input}
            label="Calendario de resultados"
            type="text"
            id="result_schedule"
            maxLength={255}
            value={values.result_schedule}
            error={errors.result_schedule}
            onChange={handleChange}
          />
        </div>

        <div className="sm-6">
          <Field
            component={Input}
            label="Calendar ID*"
            type="text"
            id="calendar_id"
            maxLength={255}
            value={values.calendar_id}
            error={errors.calendar_id}
            onChange={handleChange}
          />
        </div>

        <div className="sm-12">
          <Field
            component={Input}
            label="Código da Unidade Profissional"
            type="text"
            id="professional_code"
            maxLength={255}
            value={values.professional_code}
            error={errors.professional_code}
            onChange={handleChange}
          />
        </div>

        {unitId && (
          <div className="sm-">
            <Box mb="20">
              <Button
                onClick={refetchQrCode}
                disabled={isDownloadingQr}
                type="button"
              >
                {isDownloadingQr ? "Baixando..." : "Download QR Code"}
              </Button>
            </Box>
          </div>
        )}
      </div>
    </PanelContent>
  );
}
